import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Header from '../components/header';
import Footer from '../components/footer';

import '../../sass/style.scss';

const TemplateWrapper = (props) => (
  <div>
    <Helmet
      title={props.data.allDataJson.edges[0].node.es[0].title}
    />
    <Header data={props.data.allDataJson.edges[0].node.es[0].parts} langu="en" />
    
    
    
     {props.children()}
    <Footer />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;

export const pageQuery = graphql`
  query IndexQueryOtherEs {
     allDataJson {
    edges {
      node {
        es {
          title
          ctabutton
          parts {
            content
            title
            image
            link 
            list
            social
            id
          } 
        } 
      }
    }
  }
  }
`;


// WEBPACK FOOTER //
// ./src/layouts/es.js